<template>
<div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">

        <!-- SLIDE 1 -->
        <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Tema 1: Etapas cognoscitivas según Piaget / pág. 1">
            <div class="container-fluid margen_principal">
                <div class="row" id="slide-1">
                    <div class="col-lg-12 col-md-12 col-12">
                        <div class="row mt-4">
                            <div class="col-lg-5 col-md-12">
                                <h2>1. Etapas cognoscitivas según Piaget</h2>
                                <div class="d-flex justify-content-center mt-4">
                                    <div>
                                        <b-img src="recursos/img/DCSS0_09_Tema1_Fig1.png" class="d-flex mx-auto" fluid alt="Etapas cognoscitivas según Piaget"></b-img>
                                        <p class="text-center txtfiguras mt-3">Fuente: Standret (s. f.). Recuperada de <span class="url"><a href="https://www.freepik.es/foto-gratis/hermanito-hermanita-jugando-cajas-carton-guarderia_9277126.htm#page=5&query=ni%C3%B1os+jugando&position=1" target="_blank">https://www.freepik.es</a></span> </p>
                                    </div>
                                </div>
                                <p>Las etapas cognoscitivas de Piaget son procesos que se dan por edades, en las que el ser humano construye el conocimiento, al ir desarrollándose. Este epistemólogo:</p>
                                <div class="citacion1 p-4">
                                    <p class="mb-0 pb-0">[…] describió su trabajo como <i>epistemología genética</i> (es decir, los orígenes del pensamiento). La genética es el estudio científico de dónde vienen las cosas (sus orígenes). La epistemología se ocupa de las categorías básicas del pensamiento, es decir, del marco o de las propiedades estructurales de la inteligencia (Tacca, 2018, p. 142).</p>
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-12 offset-lg-2 mt-lg-0 mt-4">

                                <p class="mt-3">Coon (1999) menciona que esta perspectiva, la <i>epistemología genética</i> de Piaget, toma 3 conceptos de la teoría de Darwin: adaptación, asimilación (incorporación de la información, hace alusión a las funciones superiores) y acomodación (ajustamos la información).</p>
                                <p>En cada etapa, el pensamiento del niño es cualitativamente diferente y nunca retrocede a un estado previo. Las etapas descritas por Piaget (1972) son:</p>

                                <h6 class="text-center my-4">Haga clic en los botones para conocer las etapas cognoscitivas según Piaget.</h6>

                                <div class="accordion shadowCollapsable" role="tablist">
                                    <b-card no-body class="borderinferiorCollapsable">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-1 class="btnColapsable">Etapa sensoriomotora</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                                <p class="mb-0 pb-0">Es la primera etapa de división del desarrollo cognitivo del niño. Acontece entre los 0 y 2 años de edad y se caracteriza por ser un período de rápido crecimiento cognitivo, los niños muestran gran curiosidad por su entorno y se produce un avance significativo desde los reflejos innatos. En esta etapa, el niño explora el mundo a través del ensayo-error y las interacciones motoras y sensoriales con los objetos, utilizando sus sentidos y acciones; conoce el mundo al coordinar experiencias sensoriales y afectivas, las cuales son elementales para la realización de los primeros hábitos.</p>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>

                                    <b-card no-body class="borderinferiorCollapsable">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-2 class="btnColapsable">Etapa preoperacional</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                                <p class="mb-0 pb-0">Es la segunda etapa propuesta por Piaget y sucede entre los 2 y 7 años. En esta, los niños usan las imágenes y el lenguaje para representar y comprender el mundo, incrementando su imaginación y creatividad; además, presentan un pensamiento egocéntrico, es decir, creen que las demás personas perciben el mundo como ellos.</p>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>

                                    <b-card no-body class="borderinferiorCollapsable">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-3 class="btnColapsable">Etapa de operaciones concretas</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                                <p class="mb-0 pb-0">Esta etapa abarca el periodo de los 7 a 11 años. Los niños inician con actividades mentales del pensamiento lógico; gracias a estas operaciones cognoscitivas, comprenden las propiedades básicas y asocian los objetos con eventos cotidianos, privilegiando la observación del comportamiento de otros.</p>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>

                                    <b-card no-body>
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-4 class="btnColapsable">Etapa de operaciones formales</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                                <p class="mb-0 pb-0">Esta última etapa es desde los 11 años en adelante. Aquí el pensamiento es sistemático y abstracto, dando paso a la capacidad de razonar sobre supuestos o hipótesis. </p>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                                <h6 class="text-center my-4">Haga clic en el botón para conocer la tabla 1, titulada <strong>Piaget y las etapas del desarrollo cognitivo: ideas clave</strong> </h6>
                                <b-button v-b-modal.modal-Tema1Slide1 class="d-flex mx-auto mt-4 BtnPrincipal mb-5">Tabla 1</b-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- SLIDE 1 -->
        <ModalTema1 />
    </div>
</div>
</template>

<script>
import {
    SwiperController
} from '../assets/RecursosITM/js/Swiper'
import ModalTema1 from '@/components/Modales'

export default {
    name: 'Tema1',
    mounted() {
        SwiperController(),
            document.title = this.$route.meta.title
    },
    components: {
        ModalTema1
    }
};
</script>
